import React from 'react';
import { Trans } from '@lingui/react/macro';
import { faFileCheck, faFileSignature } from '@fortawesome/pro-light-svg-icons';
import { Badge } from '@ygtechnologies/rubus-ui';

import { ConfiguratorGroupDto } from '@/services/configurator';
import { isDeadlineInPast } from '@/utils/date';
import { isGroupSigned } from '../shared/isGroupSigned';

interface Props {
    group: ConfiguratorGroupDto;
    deadlineDate: Date | string;
}

export const OptionRowStatus: React.FC<Props> = ({ group, deadlineDate }) => {
    const signed = isGroupSigned(group);
    if (signed) {
        return (
            <Badge size="sm" variant="success" appearance="subtle" iconLeft={faFileCheck}>
                <Trans>Signed</Trans>
            </Badge>
        );
    }
    if (isDeadlineInPast(deadlineDate)) {
        return (
            <Badge size="sm" variant="danger" appearance="subtle" iconLeft={faFileSignature}>
                <Trans>Deadline expired</Trans>
            </Badge>
        );
    }
    return (
        <Badge size="sm" variant="warning" appearance="subtle" iconLeft={faFileSignature}>
            <Trans>Waiting for signature</Trans>
        </Badge>
    );
};
